import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import TeamSection from '../components/TeamSection';

export default function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <TeamSection />
    </main>
  );
}
